// extracted by mini-css-extract-plugin
module.exports = {"list":"NTvsq9wL","listItem":"oDjdo4fW","linkText":"ETknk_lJ","chevron":"cjeYS3HH","link":"_372ilIj_","disabled":"gyn2PjVP"};